import { render } from "./PersonalSpaceSidebarElement.vue?vue&type=template&id=53f443f6&scoped=true"
import script from "./PersonalSpaceSidebarElement.vue?vue&type=script&lang=js"
export * from "./PersonalSpaceSidebarElement.vue?vue&type=script&lang=js"

import "./PersonalSpaceSidebarElement.vue?vue&type=style&index=0&id=53f443f6&lang=scss&scoped=true"
/* custom blocks */
import block0 from "@/locales/common.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusr%2Fapp%2Fsrc%2Fcomponents%2Felements%2FPersonalSpaceSidebarElement.vue&external"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locales/components/elements/personal-space-sidebar-element.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fusr%2Fapp%2Fsrc%2Fcomponents%2Felements%2FPersonalSpaceSidebarElement.vue&external"
if (typeof block1 === 'function') block1(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53f443f6"]])

export default __exports__